module.exports = __webpack_public_path__ + "img/logo.5aa3a6e7.png";